import {
  CLEAR_CREATE_TRANSACTION,
  SET_TRANSACTION_REQUEST_DROPDOWN_VALUE,
} from "../action";
import { transactionRequest } from "./initial-store";

const initialState = transactionRequest;

function transactionRequestReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_TRANSACTION_REQUEST_DROPDOWN_VALUE:
      newState = {
        ...state,
        [action.payload.domainName]: action.payload.domainValue,
      };
      return newState;

    case CLEAR_CREATE_TRANSACTION:
      newState = initialState;
      return newState;

    default:
      return state;
  }
}

export default transactionRequestReducer;
